import { Button } from "@mui/material";

type PostAction = "discard" | "disable" | "save" | "update" | "publish";

const STATUS_ACTIONS: Record<string, readonly PostAction[]> = {
  Draft: ["discard", "save", "publish"],
  Received: ["discard", "save", "publish"],
  Published: ["disable", "update"],
  Disabled: ["update", "publish"],
};

type Props = {
  isEdit: boolean;
  status?: string;
  onDiscard?: () => void;
  onDisable?: () => void;
  onSave?: () => void;
  onUpdate?: () => void;
  onPublish?: () => void;
};

const PostFormActions = ({
  isEdit,
  status,
  onDiscard,
  onDisable,
  onSave,
  onUpdate,
  onPublish,
}: Props) => {
  const actions = isEdit
    ? STATUS_ACTIONS[status ?? ""] ?? []
    : (["save", "publish"] as const);

  return (
    <>
      {actions.includes("discard") && (
        <Button type="button" variant="outlined" color="error" onClick={onDiscard}>
          Discard
        </Button>
      )}
      {actions.includes("disable") && (
        <Button type="submit" variant="contained" color="warning" onClick={onDisable}>
          Disable
        </Button>
      )}
      {actions.includes("save") && (
        <Button variant="outlined" onClick={onSave}>
          Save
        </Button>
      )}
      {actions.includes("update") && (
        <Button type="submit" variant="contained" onClick={onUpdate}>
          Update
        </Button>
      )}
      {actions.includes("publish") && (
        <Button type="submit" variant="contained" onClick={onPublish}>
          Publish
        </Button>
      )}
    </>
  );
};

export default PostFormActions;
